import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Link,
  Typography,
} from '@forgeglobal/design-framework';
import React, { useState } from 'react';
import { useStyles } from './styles';

export interface LoginLinkProps {
  linkDescription: string;
  title: string;
  bodyContent: JSX.Element;
}

export const LoginLink: React.FC<LoginLinkProps> = ({
  linkDescription,
  title,
  bodyContent,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const id = title.replace(/ /g, ''); //replaceAll is not available in older browsers

  const openModal = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Box mt={1}>
        <Grid item container justifyContent="center" spacing={1}>
          <Grid item container justifyContent="center">
            <Typography variant="body1" data-test-id={`loginLink-${id}-text`}>
              {`${linkDescription}  `}
              <Link
                className={classes.link}
                data-test-id={`loginLink-${id}-button`}
                onClick={openModal}>
                Click here
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Dialog
        open={!!isOpen}
        transitionDuration={0}
        disableEnforceFocus
        maxWidth={false}>
        <DialogTitle onClose={onClose}>{title}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" className={classes.dialogContent}>
            {bodyContent}
          </Typography>
          <div className={classes.buttonContainer}>
            <Button variant="contained" color="primary" onClick={onClose}>
              Ok
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
